import Router from "vue-router";
import Vue from "vue";
import menuModule from "vuex-store/modules/menu";

Vue.use(Router);

export default new Router({
  mode: "hash",
  linkActiveClass: "is-active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: "Profile",
      path: "/profile",
      meta: {
        auth: true,
        label: "Profile",
        breadcrumb: [{ name: "Profile" }]
      },
      component: () => import("views/profile/index")
    },
    {
      name: "login",
      path: "/login",
      meta: { public: true, auth: false },
      component: () => import("views/login/index")
    },
    {
      name: "404",
      path: "/404",
      meta: { public: true, auth: true },
      component: () => import("views/404")
    },
    {
      name: "403",
      path: "/403",
      meta: { public: true, auth: true },
      component: () => import("views/403")
    },
    {
      name: "register",
      path: "/register",
      meta: { public: true, auth: false },
      component: () => import("views/register/index")
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: "*",
      redirect: "/dashboard"
    },
    {
      name: "Payment Method",
      path: "/advanced_settings/payment",
      meta: {
        auth: true
      },
      component: () => import("views/advanced_settings/payment_method/index")
    },
    {
      name: "payment_method_create",
      path: "/advanced_settings/payment/create",
      meta: { auth: true, label: "Create " },
      component: () => import("views/advanced_settings/payment_method/create")
    },
    {
      name: "payment_method_edit",
      path: "/advanced_settings/payment/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ link: "/advanced_settings/?tab=payment" }]
      },
      component: () => import("views/advanced_settings/payment_method/edit")
    },
    {
      name: "category_create",
      path: "/product_entry/category/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Create", link: "/product_entry?tab=categories" }]
      },
      component: () => import("views/setting/product_entry/categories/create")
    },
    {
      name: "category_edit",
      path: "/product_entry/category/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ link: "/product_entry?tab=categories" }]
      },
      component: () => import("views/setting/product_entry/categories/edit"),
      props: true
    },
    {
      name: "category_add_product",
      path: "/product_entry/category/add_product/:id",
      meta: { auth: true, label: "Add Product to Category" },
      component: () =>
        import("views/setting/product_entry/categories/add-product")
    },
    {
      name: "award_create",
      path: "/product_entry/award/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Create", link: "/product_entry?tab=awards" }]
      },
      component: () => import("views/setting/product_entry/awards/create")
    },
    {
      name: "award_edit",
      path: "/product_entry/award/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ link: "/product_entry?tab=awards" }]
      },
      component: () => import("views/setting/product_entry/awards/edit"),
      props: true
    },
    {
      name: "tag_product_entry_create",
      path: "/product_entry/tag/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Create", link: "/product_entry?tab=wine_types" }]
      },
      component: () => import("views/setting/product_entry/wine_types/create")
    },
    {
      name: "tag_product_entry_edit",
      path: "/product_entry/tag/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Wine types", link: "/product_entry?tab=wine_types" }]
      },
      component: () => import("views/setting/product_entry/wine_types/edit")
    },
    {
      name: "wine_styles_create",
      path: "/product_entry/wine_style/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Create", link: "/product_entry?tab=wine_styles" }]
      },
      component: () => import("views/setting/product_entry/wine_styles/create")
    },
    {
      name: "wine_styles_edit",
      path: "/product_entry/wine_style/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Wine styles", link: "/product_entry?tab=wine_styles" }]
      },
      component: () => import("views/setting/product_entry/wine_styles/edit")
    },
    {
      name: "regions_create",
      path: "/product_entry/regions/create",
      meta: {
        public: false,
        auth: true,
        label: "Create ",
        breadcrumb: [
          {
            name: "Create",
            link: "/product_entry?tab=regions"
          }
        ]
      },
      component: () => import("views/setting/product_entry/regions/create")
    },
    {
      name: "regions_edit",
      path: "/product_entry/regions/edit/:id",
      meta: {
        public: false,
        auth: true,
        label: "Edit ",
        breadcrumb: [
          {
            name: "Regions",
            link: "/product_entry?tab=regions"
          }
        ]
      },
      component: () => import("views/setting/product_entry/regions/edit")
    },
    {
      name: "wine_classifications_create",
      path: "/product_entry/wine_classifications/create",
      meta: {
        public: false,
        auth: true,
        label: "Create ",
        breadcrumb: [
          {
            name: "Create",
            link: "/product_entry?tab=wine_classifications"
          }
        ]
      },
      component: () => import("views/setting/product_entry/wine_classifications/create")
    },
    {
      name: "wine_classifications_edit",
      path: "/product_entry/wine_classifications/edit/:id",
      meta: {
        public: false,
        auth: true,
        label: "Edit ",
        breadcrumb: [
          {
            name: "Wine Classifications",
            link: "/product_entry?tab=wine_classifications"
          }
        ]
      },
      component: () => import("views/setting/product_entry/wine_classifications/edit")
    },
    {
      name: "bottle_sizes_create",
      path: "/product_entry/bottle_sizes/create",
      meta: {
        public: false,
        auth: true,
        label: "Create ",
        breadcrumb: [
          {
            name: "Create",
            link: "/product_entry?tab=bottle_sizes"
          }
        ]
      },
      component: () => import("views/setting/product_entry/bottle_sizes/create")
    },
    {
      name: "bottle_sizes_edit",
      path: "/product_entry/bottle_sizes/edit/:id",
      meta: {
        public: false,
        auth: true,
        label: "Edit ",
        breadcrumb: [
          {
            name: "Bottle Sizes",
            link: "/product_entry?tab=bottle_sizes"
          }
        ]
      },
      component: () => import("views/setting/product_entry/bottle_sizes/edit")
    },
    {
      name: "countries_create",
      path: "/product_entry/countries/create",
      meta: {
        public: false,
        auth: true,
        label: "Create ",
        breadcrumb: [
          {
            name: "Create",
            link: "/product_entry?tab=countries"
          }
        ]
      },
      component: () => import("views/setting/product_entry/countries/create")
    },
    {
      name: "countries_edit",
      path: "/product_entry/countries/edit/:id",
      meta: {
        public: false,
        auth: true,
        label: "Edit ",
        breadcrumb: [
          {
            name: "Countries",
            link: "/product_entry?tab=countries"
          }
        ]
      },
      component: () => import("views/setting/product_entry/countries/edit")
    },
    {
      name: "grape_create",
      path: "/product_entry/grapes/create",
      meta: {
        public: false,
        auth: true,
        label: "Create Grape",
        breadcrumb: [
          {
            name: "Create",
            link: "/product_entry?tab=grapes"
          }
        ]
      },
      component: () =>
        import("views/setting/product_entry/grapes/create")
    },
    {
      name: "grape_edit",
      path: "/product_entry/grapes/edit/:id",
      meta: {
        public: false,
        auth: true,
        label: "Edit Grape",
        breadcrumb: [
          {
            name: "Grapes",
            link: "/product_entry?tab=grapes"
          }
        ]
      },
      component: () =>
        import("views/setting/product_entry/grapes/edit")
    },
    {
      name: "product_create",
      path: "/product/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Products", link: "/product" }, { name: "Create" }]
      },
      component: () => import("views/products/create")
    },
    {
      name: "product_edit",
      path: "/product/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Products", link: "/product" }]
      },
      component: () => import("views/products/edit")
    },
    {
      name: "post_create_copy",
      path: "/post/create/:id",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [{ name: "Posts", link: "/post" }, { name: "Create" }]
      },
      component: () => import("views/post/create")
    },
    {
      name: "Create Membership",
      path: "/memberships/create",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [
          { name: "Memberships", link: "/memberships" },
          { name: "Create" }
        ],
        label: "Create Membership"
      },
      component: () => import("views/customer_type/create")
    },
    {
      name: "Edit Membership",
      path: "/memberships/edit/:id",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "Memberships", link: "/memberships" }],
        label: "Edit Membership"
      },
      component: () => import("views/customer_type/edit")
    },
    {
      name: "membership_order_edit",
      path: "/membership-orders/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Membership Orders", link: "/membership-orders" }]
      },
      component: () => import("views/membership_order/edit")
    },
    {
      name: "customer_create",
      path: "/customer/create",
      meta: {
        auth: true,
        breadcrumb: [
          { name: "Customers", link: "/customer" },
          { name: "Create" }
        ],
        label: "Create"
      },
      component: () => import("views/customer/create")
    },
    {
      name: "customer_detail",
      path: "/customer/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Customers", link: "/customer" }]
      },
      component: () => import("views/customer/detail")
    },
    {
      name: "order_edit",
      path: "/order/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Orders", link: "/order" }]
      },
      component: () => import("views/order/edit")
    },
    {
      name: "stock",
      path: "/stock",
      meta: {
        auth: true,
        label: "Live Stock"
      },
      component: () => import("views/stock/index-stock")
    },
    {
      name: "subscription",
      path: "/subscription",
      meta: {
        auth: true,
        label: "Subscriptions"
      },
      component: () => import("views/subscription/index")
    },
    {
      name: "shipper_create",
      path: "/shipper/create",
      meta: { auth: true, label: "Create Shipper" },
      component: () => import("views/shippers/create")
    },
    {
      name: "shipper_edit",
      path: "/shipper/edit/:id",
      meta: { auth: true, label: "Edit Shipper" },
      component: () => import("views/shippers/edit")
    },
    {
      name: "warehouse_create",
      path: "/warehouse/create",
      meta: { auth: true, label: "Create Warehouse" },
      component: () => import("views/warehouses/create")
    },
    {
      name: "warehouse_edit",
      path: "/warehouse/edit/:id",
      meta: { auth: true, label: "Edit Warehouse" },
      component: () => import("views/warehouses/edit")
    },
    {
      name: "report",
      path: "/report",
      meta: { auth: true, label: "report" },
      component: () => import("views/report/subscription")
    },
    {
      name: "notification",
      path: "/notification",
      meta: {
        auth: true,
        label: "Notification",
        breadcrumb: [{ name: "Notifications" }]
      },
      component: () => import("views/notification/index")
    },
    {
      name: "release",
      path: "/release-notes",
      meta: {
        auth: true,
        label: "Release Notes",
        breadcrumb: [{ name: "Release Notes" }]
      },
      component: () => import("views/release/index")
    }
  ]
});

function generateRoutesFromMenu(menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
      let item = menu[i];

    if (item.path) {
      routes.push(item);
    }

    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }

  return routes;
}
